module.exports = __webpack_public_path__ + "media/images/pages/bg_area_13-993c4666f3d75378287cff7f7740f0ec.png";